import { isKds, kdsRoot } from 'src/config'
import Model from 'src/models/Model'

export default ({ router, app }) => {
  if (!isKds) return

  async function quitKds () {
    if (Model.context.currentKdsClient) {
      await Model.context.currentKdsClient.delete()
    }
    if (Model.context.currentUser) {
      await Model.context.currentUser.logOut()
    }
    await Model.configuration.validate()
    await Model.context.fetch(true)
    router.replace({ name: 'auth:login' })
  }
  app.config.globalProperties.$quitKds = quitKds
  app.$quitKds = quitKds

  /**
   * Set routes
   */
  const routeData = {
    name: 'kds:root',
    path: kdsRoot,
    component: () => import('src/modules/kds/layouts/KdsLayout.vue'),
    beforeEnter: async (_to, _from, next) => {
      await Model.configuration.ensureLoaded()

      // If not logged in, force login
      if (!Model.context.currentUser) {
        next({ name: 'auth:login' })
        return
      }

      next()
    }
  }

  router.addRoute(routeData)

  if (isKds) {
    router.addRoute({ name: 'app:root', redirect: { name: 'kds:root' } })
  }
}
